export enum OrderTypeEnum {
  "BUY",
  "SELL",
  "BUY LIMIT",
  "SELL LIMIT",
  "BUY STOP",
  "SELL STOP",
  "BUY STOP LIMIT",
  "SELL STOP LIMIT",
  "CLOSE BY",
}

export enum OrderStateEnum {
  "STARTED",
  "PLACED",
  "CANCELED",
  "PARTIAL",
  "FILLED",
  "REJECTED",
  "EXPIRED",
  "REQUEST ADD",
  "REQUEST MODIFY",
  "REQUEST CANCEL",
}

export enum OrderReasonEnum {
  "CLIENT",

  "EXPERT",

  "DEALER",

  "SL",

  "TP",

  "SO",

  "ROLLOVER",

  "EXTERNAL CLIENT",

  "VMARGIN",

  "GATEWAY",

  "SIGNAL",

  "SETTLEMENT",

  "TRANSFER",

  "SYNC",

  "EXTERNAL SERVICE",

  "MIGRATION",

  "MOBILE",

  "WEB",

  "SPLIT",

  "CORPORATE ACTION",

  "FIRST",

  "LAST",
}
